import { ToastPopupProps } from '@common/toast';
import { BeforeUpload } from '@common/upload';
import {
  allFileAllowedExtensions,
  profileAllowedExtensions,
  profileImageAllowedExtensions,
} from '@domain/constant/fileExtention';
import FileUtil from '@utils/fileUtil';

const LIMIT_COUNT = 20;

export const profileBeforeUpload: BeforeUpload = (file, files, fileCount, showToast) => {
  return checkFileBeforeUpload(file, profileAllowedExtensions, 50, 'MB', fileCount, LIMIT_COUNT, showToast);
};

export const profileImageBeforeUpload: BeforeUpload = (file, files, fileCount, showToast, accepts) => {
  return checkFileBeforeUpload(
    file,
    profileImageAllowedExtensions,
    50,
    'MB',
    fileCount,
    LIMIT_COUNT,
    showToast,
    accepts,
  );
};

export const additionalBeforeUpload: BeforeUpload = (file, files, fileCount, showToast) => {
  return checkFileBeforeUpload(file, allFileAllowedExtensions, 50, 'MB', fileCount, LIMIT_COUNT, showToast);
};

export const checkFileBeforeUpload = (
  file: File,
  allowedExtensions: string[],
  limitSize: number,
  limitSizeUnit: 'KB' | 'MB',
  fileCount: number,
  limitCount: number,
  Toast: (options: ToastPopupProps) => void,
  accepts?: string[],
) => {
  const isInvalidExt = !FileUtil.checkFileExtArr(file, allowedExtensions, true);
  const isInvalidSize = !FileUtil.checkFileSize(file.size, limitSize, limitSizeUnit);
  const isInvalidCount = fileCount > limitCount;
  const isImage = accepts?.includes('.jpg') || accepts?.includes('.png');

  if (isInvalidExt) {
    Toast({
      type: 'error',
      iconType: 'info',
      content: isImage ? 'JPG, PNG 파일을 업로드 해주세요.' : '잘못된 파일 형식입니다',
    });

    return false;
  }

  if (isInvalidSize) {
    Toast({
      type: 'error',
      iconType: 'info',
      content: '50MB 미만의 파일만 업로드 할 수 있습니다.',
    });

    return false;
  }

  if (isInvalidCount) {
    Toast({
      type: 'error',
      iconType: 'info',
      content: `파일은 최대 ${limitCount}개까지 등록할 수 있습니다.`,
    });

    return false;
  }

  return true;
};
